import { AfterViewInit, Component, Injectable, OnInit } from '@angular/core';

import { AetImportUploadRequestDto, FtpfileImportService } from 'src/app/services/ftpfile-import.service';
import * as FileSaver from 'file-saver-es';
import { LogImgCellRenderComponent } from 'src/app/core/grid-renderer/log-img-cell-render/log-img-cell-render.component';
import { GetTemplateService } from 'src/app/services/get-template.service';
import { ImportLogComponent } from 'src/app/core/check/import-log/import-log/import-log.component';
import { Constants, FILE_UPLOAD_TIMEOUT, generateRandomString } from 'src/app/constants';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { CommentRendererComponent } from 'src/app/core/grid-renderer/comment.grid-renderer';
import { AetStateService } from 'src/app/services/aet-state.service';
import { Router } from '@angular/router';
import moment from 'moment';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CustomFilterComponent } from './custom-filter.component'
import { GridOptions } from 'ag-grid-community';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WebSocketService } from 'src/app/services/websocket.service';
import { environment } from 'src/environments/environment';
import { catchError, EMPTY, takeWhile, timeout } from 'rxjs';
import { buildAetUserContext } from 'src/app/core/constant/user-context.util';
import * as XLSX from 'xlsx';



@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-import-ftp-file-import',
  templateUrl: './import-ftp-file-import.component.html',
  styleUrls: ['./import-ftp-file-import.component.scss'],
  standalone: false // NOSONAR
})
export class ImportFtpFileImportComponent implements OnInit {

  public step: any[] = [];


  //ag-grid-specs
  gridApi: any;
  columnDefs: any[] = [];
  rowHeight = 30;
  icons: {};
  rowCount!: number;
  paginationPageSize: number = 10;
  displayRowData: any;
  currentPageNo: number = 0;
  isLastPageFound!: boolean;
  totalPage: number = 0;
  currentPageForTotalPage: number = 0;
  rowClassRules: any;
  errorMessage: any;
  successMessage: string | undefined;
  pageNumber: any;
  pageSize: any;
  gridOptions: GridOptions | undefined;
  firstRowIndex: number = 0;
  lastRowIndex: number = 0;
  startResult: number = 0;
  pageSize1: number = 0;
  endResult: number = 0;
  templateFile: any;
  value: string;
  upload: boolean = false;
  defaultColDef: {};
  isAccessible = true;
  filterValue: any;
  interval: any;
  currentPageCheck: any;
  totalPageCheck: any;
  columnFilterArr = [{ colId: 'jobName' }, { colId: 'namc' }, { colId: 'status' }, { colId: 'fileName' }, { colId: 'startTime' }, { colId: 'finishTime' }];
  selectedFileName: any;
  selectedFilePath: any;
  const_msg = "Please select the file first" ; const_msg_file = 'application/vnd.ms-excel' ; const_tl = '#lbTotalPages' ; const_crp='#lbCurrentPage'
  private readonly supportedImportExtensions = ['.xlsx', '.xls', '.csv'];
  private uploadProgressLogs: string[] = [];
  private importLogDialogRef?: MatDialogRef<ImportLogComponent>;
  constructor(public dialog: MatDialog,
     public readonly summaryService : FtpfileImportService,
    public readonly getTemplateService: GetTemplateService,
     private readonly  ngxUiLoaderService : NgxUiLoaderService,
    private  readonly constants: Constants,
    private readonly  DatePipe: DatePipe,
     private readonly aetStateService : AetStateService,
  private readonly router: Router,
  private readonly webSocketService: WebSocketService,
  private readonly http: HttpClient) {
    this.defaultColDef = {
      suppressMovable: true,
      wrapHeaderText: true,

      autoHeight: true,
      floatingFilterComponentFramework: CustomFilterComponent,
      floatingFilterComponentParams: {
        suppressFilterButton: true,
        filterChangedCallback: (value, colId, key) => {

          this.columnFilterArr.forEach((ele) => {
            if (ele.colId == colId) { // NOSONAR
              ele['value'] = value.toLocaleLowerCase();
              ele['key'] = key;
            }
          });
          if (key == "Enter") { // NOSONAR
            this.filterAPI();
          }
        }
      },
      floatingFilter: true,
    }

    this.columnDefs = [
      {
        headerName: "Job Name", field: "jobName",
        // floatingFilterComponentParams: { suppressFilterButton: true },
        // floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 90,
        maxWidth: 120,
        resizable: true,


      },
      {
        headerName: "Code", field: "namc",
        //floatingFilterComponentParams: { suppressFilterButton: true },
        //floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 85,
        maxWidth: 120,


        //resizable:true
      },
      {
        headerName: "Status", field: "status",
        // floatingFilterComponentParams: { suppressFilterButton: true }, 
        //floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true,
        minWidth: 90,
        maxWidth: 140,
        cellStyle: this.cellStyle, resizable: false
      },
      {
        headerName: "File Name", field: "fileName",
        //floatingFilterComponentParams: { suppressFilterButton: true }, 
        //floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 300,
        //maxWidth: 350, 
        resizable: false, cellStyle: { cursor: 'pointer' },
        cellRendererFramework: CommentRendererComponent,
      },
      {
        headerName: "Start", field: "startTime",
        // floatingFilterComponentParams: { suppressFilterButton: true },
        // floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 110,
        maxWidth: 190,
        resizable: false,
        comparator: this.dateComparator
      },
      {
        headerName: "End", field: "finishTime",
        //floatingFilterComponentParams: { suppressFilterButton: true },
        // floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, minWidth: 110,
        maxWidth: 190,
        resizable: false,
        comparator: this.dateComparator
      },
      {
        headerName: "Logs", field: "logs", minWidth: 70,
        maxWidth: 85,
        cellRenderer: LogImgCellRenderComponent, resizable: false
      },
    ];

    this.gridOptions = {
      columnDefs: this.columnDefs,
    }

    this.icons = {
      sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">',
    };

    this.rowClassRules = {
      'row-even': 'node.rowIndex % 2 == 0', // NOSONAR
      'row-odd': 'node.rowIndex % 2 != 0',  // NOSONAR
    };
  }

  ngOnInit() {  // NOSONAR
    // this.checkRoles();
  }

  // ngAfterViewInit() {
  //   let f = localStorage.getItem('footerheight');
  //   let h = localStorage.getItem('headerHeight');
  //   let t = localStorage.getItem('toolbarheight');
  //   console.info(f, h, t);
  //   let windowh = window.innerHeight;
  //   let headerfilter = document.getElementById('headerfilter')?.offsetHeight;
  //   let footerfilter = document.getElementById('footerfilter')?.offsetHeight;
  //   let paginationfooter = document.getElementById('footerfilter')?.offsetHeight;
  //   console.info(headerfilter, "headerfilter")
  //   const grid = document.getElementById('LIOS-grid');
  //   if (grid !=   null && headerfilter !=   null && footerfilter !=   null) {
  //     let gridHeight = (headerfilter + footerfilter +Number(f) + Number(h) + Number(t));
  //     grid.style.height = 'calc(100vh - ' + (gridHeight) + 'px)';
  //     grid.style.maxHeight = 'calc(100vh - ' + (gridHeight) + 'px)';
  //   }
  // }

  async checkRoles() {
    await this.aetStateService.getRoles();
    const roles = this.aetStateService.getroleState();
    const userRoles = JSON.parse(roles);
    

    if(userRoles && (userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter) || 
    userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) 
    || userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) || userRoles.includes(this.constants.LIOS_UAC_AET_LP) 
    || userRoles.includes(this.constants.LIOS_UAC_General_User))){
      this.isAccessible = true;


    }
    else{
      this.router.navigate([`/home`]);
    }
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter ||
    //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
    //   // this.isAccessible = true;
    // } else {
    //   this.router.navigate([`/home`]);
    // }
  }

  dateComparator(date1, date2) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);
    if (date1Number == null && date2Number == null) { // NOSONAR
      return 0;
    }
    if (date1Number == null) { // NOSONAR
      return -1;
    }
    if (date2Number == null) { // NOSONAR
      return 1;
    }
    return Number(date1Number) - Number(date2Number);
  }
  checkFile(event: any) {
    this.errorMessage = null;
    if (event == false) // NOSONAR
      {this.errorMessage = 'Events or Resolutions Worksheet is missing in the uploaded file.'}
  }
  apiCall(pageSize: any) {
    this.errorMessage = null;
    this.successMessage = null;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.displayRowData = [];
    this.summaryService.loadOnLoad(this.pageNumber, pageSize)?.subscribe(
      (response: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.displayRowData = response.liosJobLogList.map((item: any) => {
          return {
            ...item,
            startTime: this.dateFormatter(item.startTime),
            finishTime: this.dateFormatter(item.finishTime),
          };
        });
        this.gridApi.applyTransaction({ add: this.displayRowData });
        this.rowCount = response.navOptions.totalRecords;
        this.currentPageCheck = response.navOptions.page;
        this.totalPageCheck = response.navOptions.numberOfPages;
        if (response.liosJobLogList.length == 0) { // NOSONAR
          this.currentPageCheck = 0;
          this.totalPageCheck = 0;
          this.setText(this.const_crp, this.currentPageCheck);
          this.setText(this.const_tl, this.totalPageCheck);
        }
        this.gridApi?.redrawRows();
      },
      error => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
        this.gridApi.applyTransaction({ add: this.displayRowData });
        console.info(error)
      }
    );
  }

  // downloadTemp() {
  //   this.errorMessage = null;
  //   this.successMessage = null;
  //   this.ngxUiLoaderService.start(CommonConstant.loader);
  //   this.getTemplateService.getImportTemplate()
  //     .subscribe({
  //       next: (response) => {
  //         this.ngxUiLoaderService.stop(CommonConstant.loader);
  //         let filename = "AETImport-Template"
  //         const data: Blob = new Blob([(<any>response).body], { type: 'application/vnd.ms-excel' });
  //         FileSaver.saveAs(data, filename);
  //       },
  //       error: () => {
  //         this.ngxUiLoaderService.stop(CommonConstant.loader);
  //         this.errorMessage = this.constants.APIErrorMessage;

  //       }
  //     })
  // }

  downloadTemp() {
    this.errorMessage = null;
    this.successMessage = null;
    this.ngxUiLoaderService.start(CommonConstant.loader);

    this.getTemplateService.getImportTemplate()
      .subscribe({
        next: (response) => {
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          const filename = 'AETImport-Template';
          const data: Blob = new Blob([(<any>response).body], { type: this.const_msg_file });
          FileSaver.saveAs(data, filename);
        },
        error: () => {
          const token =
            sessionStorage.getItem('accessToken') ||
            sessionStorage.getItem('idToken') ||
            localStorage.getItem('accessToken') ||
            '';
          const templateFileNames = ['AETImport_Template.xls', 'AETImport-Template.xls'];
          const fileNames = templateFileNames.reduce((acc: string[], fileName: string) => {
            acc.push(`AET/${fileName}`, fileName);
            return acc;
          }, []);
          this.tryDownloadTemplate(fileNames, token, 0);
        }
      });
  }

  private tryDownloadTemplate(fileNames: string[], token: string, index: number) {
    if (index >= fileNames.length) {
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      this.errorMessage = 'Template download failed. Please contact support.';
      return;
    }

    const fileName = fileNames[index];
    const fullUrl = `${environment.TEMPLATE_EXCEL_URI}/${fileName}`;

    const headerMap: Record<string, string> = {
      'x-auth-token': token,
      'X-Auth-Token': token,
    };

    if (token) {
      headerMap['Authorization'] = `Bearer ${token}`;
    }

    const headers = new HttpHeaders(headerMap);

    this.http.get(fullUrl, { headers, responseType: 'blob' })
      .subscribe({
        next: (blob: Blob) => {
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          FileSaver.saveAs(blob, fileName.split('/').pop() || 'AETImport-Template.xls');
        },
        error: (err) => {
          if ((err?.status === 404 || err?.status === 403) && index < fileNames.length - 1) {
            this.tryDownloadTemplate(fileNames, token, index + 1);
            return;
          }
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          this.errorMessage = 'You are not authorized to download this template or the file does not exist.';
        }
      });

  }

  const_fit = 'fit-content'
  cellStyle(params: any) {
    if (params.value == "FAILED") { // NOSONAR
      return { 'background-color': '#EA5A5A', 'color': '#FFFFFF', 'border-radius': '25px', 'max-width': this.const_fit, 'padding-left': '1rem', 'padding-right': '1rem', 'justify-content': 'center' };
    } else if (params.value == 'COMPLETED') { // NOSONAR
      return { 'background-color': '#24B685', 'color': '#FFFFFF', 'border-radius': '25px', 'max-width': this.const_fit, 'padding-left': '1rem', 'padding-right': '1rem', 'justify-content': 'center' };
    } else {
      return { 'background-color': '#66ccff', 'color': '#FFFFFF', 'border-radius': '25px', 'max-width': this.const_fit, 'padding-left': '1rem', 'padding-right': '1rem', 'justify-content': 'center' };
    }
  }

  dateFormatter(res) {
    return res ? moment(res).format('MM/DD/YYYY HH:mm:ss') : null;
  }

  getCurrentPageSize() {
    const currentPage = this.gridApi?.paginationGetCurrentPage();
    console.info(currentPage)
  }



  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.pageNumber = this.gridApi.paginationGetCurrentPage() + 1;
    this.apiCall(this.paginationPageSize);
  }

  setText(selector: string, text: any) {
      (document.querySelector(selector) as any).innerHTML = text;
  }

  setLastButtonDisabled(_FILE_UPLOAD_TIMEOUTdisabled: boolean) {
    this.isLastPageFound = true;
  }
  onModelUpdated(): void {
    this.sizeToFit();
  }
  sizeToFit() { this.gridApi?.sizeColumnsToFit(); }
  goToNexpage() {
    this.pageNumber++;
    this.filterAPI();
  }
  goToPreviousPage() {
    this.pageNumber--;
    this.filterAPI();
  }
  goToFirstPage() {
    this.pageNumber = 1;
    this.filterAPI();
  }

  goToLastPage() {
    this.pageNumber = Math.ceil(this.rowCount / this.paginationPageSize);
    this.filterAPI();
  }


  getCurrentPage(): boolean {
    this.currentPageNo = this.pageNumber;

    if (this.currentPageNo == 1) { // NOSONAR
      return true;
    }
    else {
      return false;
    }
  }

  isLastPage(): boolean {
    this.totalPage = Math.ceil(this.rowCount / this.paginationPageSize);
    this.currentPageForTotalPage = this.pageNumber;
    if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }

  onPaginationChanged() {
    if (this.gridApi) {
      this.setText(this.const_crp, this.currentPageCheck);
      this.setText(this.const_tl, this.totalPageCheck);
      this.setLastButtonDisabled(!this.gridApi.paginationIsLastPageFound());
    }
  }

  onPageSizeChanged(event: any) {
    this.paginationPageSize = event.target.value;
    this.gridApi?.paginationSetPageSize(Number(event.target.value));
    this.lastRowIndex = Number(this.paginationPageSize);
    this.filterAPI();
    // }

  }


  validateFile() {
    this.successMessage = null;
    this.errorMessage = null;
    if (this.templateFile) {
      const extension = this.templateFile.name.substring(this.templateFile.name.lastIndexOf('.'));
      if (this.supportedImportExtensions.includes(extension.toLowerCase())) { // NOSONAR
        this.value = 'validate';

        const toyotaGUID = localStorage.getItem('toyotaGUID');
        this.ngxUiLoaderService.start(CommonConstant.loader);
        this.summaryService.validateFileService(toyotaGUID, this.templateFile).subscribe((response) => {

          this.ngxUiLoaderService.stop(CommonConstant.loader);
          if (response.status == 200) {// NOSONAR

           
            this.successMessage = 'Events and resolutions were validated';
          }
          else {

            const filename = "AETImport_ErrorReport"
            const data: Blob = new Blob([(<any>response).body], { type: this.const_msg_file });
            FileSaver.saveAs(data, filename);
            this.importLogPopup();
          }
        }, _error => {
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          this.errorMessage = this.constants.APIErrorMessage;
          this.successMessage = null;
        });
      } else {
        this.errorMessage = 'Can accept only .xlsx, .xls and .csv files';
      }
    }
    else {
      this.errorMessage = this.const_msg;
    }
  }

  async newvalidateFile() {
    this.successMessage = null;
    this.errorMessage = null;
    if (this.templateFile) {
      const extension = this.templateFile.name.substring(this.templateFile.name.lastIndexOf('.'));
      if (this.supportedImportExtensions.includes(extension.toLowerCase())) { // NOSONAR
        this.value = 'validate';
        // Validate/import now share a single lambda/websocket flow.
        // Error report file handling is centralized in uploadAetImportFileViaLambda(...).
        await this.uploadAetImportFileViaLambda(true);
      } else {
        this.errorMessage = 'Can accept only .xlsx, .xls and .csv files';
      }
    }
    else {
      this.errorMessage = this.const_msg;
    }
  }


  importFile() {
    this.successMessage = null;
    this.errorMessage = null;
    if (this.templateFile) {
      const extension = this.templateFile.name.substring(this.templateFile.name.lastIndexOf('.'));
      if (this.supportedImportExtensions.includes(extension.toLowerCase())) { // NOSONAR
        this.value = 'import';

        const toyotaGUID = localStorage.getItem('toyotaGUID');
        this.ngxUiLoaderService.start(CommonConstant.loader);
        this.summaryService.uploadFileService(toyotaGUID, this.templateFile).subscribe((response) => {

          this.ngxUiLoaderService.stop(CommonConstant.loader);
          if (response.status == 200) { // NOSONAR

            this.templateFile = null;
            this.upload = true;
            this.successMessage = 'Events and resolutions were successfully uploaded';
          }
          else {
            const filename = "AETImport_ErrorReport"
            const data: Blob = new Blob([(<any>response).body], { type: this.const_msg_file });
            FileSaver.saveAs(data, filename);
            this.importLogPopup();
          }
        }, _error => {
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          this.errorMessage = this.constants.APIErrorMessage;;
          this.successMessage = null;
        });
      } else {
        this.errorMessage = 'Can accept only .xlsx, .xls and .csv files';
      }
    } else {
      this.errorMessage = this.const_msg;
    }
  }

  async newimportFile() {
    this.successMessage = null;
    this.errorMessage = null;
    if (this.templateFile) {
      const extension = this.templateFile.name.substring(this.templateFile.name.lastIndexOf('.'));
      if (this.supportedImportExtensions.includes(extension.toLowerCase())) { // NOSONAR
        this.value = 'import';
        // Validate/import now share a single lambda/websocket flow.
        // Error report file handling is centralized in uploadAetImportFileViaLambda(...).
        await this.uploadAetImportFileViaLambda(false);
      } else {
        this.errorMessage = 'Can accept only .xlsx, .xls and .csv files';

      }
    } else {
      this.errorMessage = this.const_msg;
    }
  }

  private async detectAetImportTemplate(file: File): Promise<{
    importType: AetImportUploadRequestDto['importType'];
    templateMeta: NonNullable<AetImportUploadRequestDto['templateMeta']>;
  }> {
    try {
      const fileBuffer = await file.arrayBuffer();
      const workbook = XLSX.read(fileBuffer, { type: 'array' });
      const sheetNames = (workbook.SheetNames || []).map((sheet) => sheet?.trim()).filter(Boolean);
      const normalizedSheetNames = sheetNames.map((sheet) => sheet.toLowerCase());
      const hasEventsSheet = normalizedSheetNames.includes('events');
      const hasResolutionsSheet = normalizedSheetNames.includes('resolutions');

      return {
        importType: hasEventsSheet && hasResolutionsSheet ? 'AET_EVENTS_RESOLUTIONS' : 'AET_IMPORT',
        templateMeta: {
          fileName: file.name,
          sheetNames,
          hasEventsSheet,
          hasResolutionsSheet,
        },
      };
    } catch (error) {
      console.info('Unable to inspect workbook template, defaulting to AET_IMPORT:', error);
      return {
        importType: 'AET_IMPORT',
        templateMeta: {
          fileName: file.name,
          sheetNames: [],
          hasEventsSheet: false,
          hasResolutionsSheet: false,
        },
      };
    }
  }

  private async uploadAetImportFileViaLambda(validationOnly: boolean): Promise<void> {
    this.uploadProgressLogs = [];

    const parsedFileName = this.templateFile?.name
      ?.replace(/\s+/g, '_')
      ?.replace(/[^a-zA-Z0-9._]/g, '_');
    this.selectedFileName = `${generateRandomString()}_${parsedFileName}`;
    this.selectedFilePath = `AET/Import/${this.selectedFileName}`;
    this.openLiveImportLogPopup(this.buildLogFileNameCandidates());
    this.pushLogsToPopup(['Processing upload file']);

    const guid = localStorage.getItem('toyotaGUID') || '';
    const detectedTemplate = await this.detectAetImportTemplate(this.templateFile);
    const requestDto: AetImportUploadRequestDto = {
      guid,
      validationOnly,
      importType: detectedTemplate.importType,
      userReqDto: buildAetUserContext(),
      templateMeta: detectedTemplate.templateMeta,
    };

    this.ngxUiLoaderService.start(CommonConstant.loader);
    try {
      const token =
        sessionStorage.getItem('accessToken') ||
        sessionStorage.getItem('idToken') ||
        localStorage.getItem('accessToken') ||
        localStorage.getItem('idToken') ||
        '';

      this.webSocketService.connect();
      await this.webSocketService.waitUntilSocketConnected();
      console.info('WebSocket connected:', this.webSocketService.isSocketConnected());
      this.webSocketService.sendMessage({
        fileName: this.selectedFilePath,
        token,
        userReqDto: requestDto.userReqDto,
        guid: requestDto.guid || '',
        isAdmin: !!requestDto?.userReqDto?.isAdmin,
        validationOnly,
        originalFileName: this.templateFile?.name || '',
      });

      const uploadUrl = `${environment.FILE_UPLOAD_URI}/${this.selectedFilePath}`;
      const userPrincipalName = requestDto?.userReqDto?.userPrincipalName || '';

      const uploadHeaders: Record<string, string> = {
        'Content-Type': this.templateFile?.type || 'application/octet-stream',
        'x-amz-meta-userid': userPrincipalName,
        'x-amz-meta-originalfilename': this.templateFile?.name || '',
        'x-amz-meta-validationonly': String(validationOnly),
        'x-amz-meta-isadmin': String(!!requestDto?.userReqDto?.isAdmin),
        'x-amz-meta-importtype': requestDto.importType,
        'x-amz-meta-guid': requestDto.guid || '',
      };

      if (token) {
        uploadHeaders['x-auth-token'] = token;
      }

      const uploadResponse = await fetch(uploadUrl, {
        method: 'PUT',
        headers: uploadHeaders,
        body: this.templateFile,
      });

      if (!uploadResponse.ok) {
        throw new Error(`Upload failed: HTTP ${uploadResponse.status}`);
      }

      this.webSocketService
        .receiveMessages()
        .pipe(
          timeout({ each: FILE_UPLOAD_TIMEOUT }),
          takeWhile((msg) => {
            return !this.isTerminalUploadMessage(msg);
          }, true), // NOSONAR
          catchError((err) => {
            if (err.name == 'TimeoutError') { // NOSONAR
              console.info(`No message received in ${FILE_UPLOAD_TIMEOUT / 1000} seconds. Closing connection.`);
              this.ngxUiLoaderService.stop(CommonConstant.loader);
              this.webSocketService.closeConnection();
              this.errorMessage = 'Failed to upload file. Please re-upload the file.';
              this.pushLogsToPopup(['Backend timeout while processing upload.']);
            } else {
              console.info('WebSocket error:', err);
              this.pushLogsToPopup(['WebSocket error while processing upload.']);
            }
            return EMPTY;
          })
        )
        .subscribe(async (messages: any) => {
          console.info(messages, 'messages from Lambda');
          this.captureUploadProgressLog(messages);

          const normalizedStatus = String(messages?.status || '').toLowerCase();
          const isTerminalStatus = ['success', 'failed', 'error'].includes(normalizedStatus);
          const backendResp = messages?.backendResponse;
          const hasFinalBackendResponse = this.isFinalBackendResponsePayload(backendResp);

          if (!isTerminalStatus && !hasFinalBackendResponse) {
            return;
          }

          try {
            this.ngxUiLoaderService.stop(CommonConstant.loader);
            if (backendResp) {
              const response = backendResp;
              const isReportResponse = Number(response?.status) === 207 || !!response?.fileBase64 || !!response?.reportDownloadUrl || response?.body !== undefined;

              if (response.status == 200) { // NOSONAR
                if (validationOnly) {
                  this.pushLogsToPopup(['Events and resolutions validated successfully']);
                  this.successMessage = 'Events and resolutions were validated';
                } else {
                  this.pushLogsToPopup(['Events and resolutions uploaded successfully']);
                  this.templateFile = null;
                  this.upload = true;
                  this.successMessage = 'Events and resolutions were successfully uploaded';
                }
              } else if (isReportResponse) {
                if (validationOnly) {
                  this.pushLogsToPopup(['Events Validation Failed']);
                }
                // Preserve legacy UX: when backend returns validation/import errors,
                // download the generated Excel error report and open the import log popup.
                const filename = response.fileName || 'AETImport_ErrorReport.xls';
                let data: Blob;

                if (response.reportDownloadUrl) {
                  const downloadResp = await fetch(response.reportDownloadUrl);
                  if (!downloadResp.ok) {
                    throw new Error(`Failed to download validation report: HTTP ${downloadResp.status}`);
                  }
                  data = await downloadResp.blob();
                } else {
                  data = response.fileBase64
                    ? this.base64ToBlob(response.fileBase64, response.contentType || this.const_msg_file)
                    : new Blob([JSON.stringify((<any>response).body ?? '')], { type: response.contentType || this.const_msg_file });
                }

                FileSaver.saveAs(data, filename);
                this.pushLogsToPopup(this.uploadProgressLogs);
              } else if (response.error) {
                this.errorMessage = response.error;
                this.pushLogsToPopup([String(response.error)]);
              } else if (response.message) {
                this.errorMessage = String(response.message);
                this.pushLogsToPopup([String(response.message)]);
              } else {
                this.errorMessage = 'Failed to process import response. Please re-upload the file.';
                this.pushLogsToPopup(['Failed to process import response. Please re-upload the file.']);
              }
            } else if (isTerminalStatus && (normalizedStatus === 'failed' || normalizedStatus === 'error')) {
              this.errorMessage = messages?.message || 'Failed to upload file. Please re-upload the file.';
              this.pushLogsToPopup([this.errorMessage]);
            }
          } catch {
            this.ngxUiLoaderService.stop(CommonConstant.loader);
            this.errorMessage = this.constants.APIErrorMessage;
            this.successMessage = null;
            this.pushLogsToPopup([this.errorMessage]);
          }
          this.webSocketService.closeConnection();
        });
    } catch (err) {
      this.upload = false;
      console.info('Unexpected upload exception:', err);
      this.webSocketService.closeConnection();
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      const backendMessage = (err as any)?.error?.message || (err as any)?.message;
      this.errorMessage = backendMessage || 'An unexpected error occurred. Please retry. Contact IS Service Desk if error persists';
      this.pushLogsToPopup([this.errorMessage]);
    }
  }

  private base64ToBlob(base64: string, contentType: string): Blob {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new Blob([bytes], { type: contentType || this.const_msg_file });
  }

  private captureUploadProgressLog(messages: any): void {
    const lines = this.extractLogLines(messages);
    lines.forEach((line) => {
      const normalized = String(line || '').trim();
      if (!normalized) {
        return;
      }
      if (!this.uploadProgressLogs.includes(normalized)) {
        this.uploadProgressLogs.push(normalized);
      }
    });

    this.pushLogsToPopup(lines);
  }

  private openLiveImportLogPopup(logFileNames: string[] = []): void {
    if (this.importLogDialogRef) {
      return;
    }

    this.importLogDialogRef = this.dialog.open(ImportLogComponent, {
      width: '619px',
      height: '400px',
      data: {
        fileSend: this.templateFile,
        valueSend: this.value,
        logsSend: [],
        logFileNames
      }
    });

    this.importLogDialogRef.afterClosed().subscribe(() => {
      this.importLogDialogRef = undefined;
    });
  }

  private pushLogsToPopup(lines: string[]): void {
    const allLines = this.buildPopupLogs(lines);
    if (this.importLogDialogRef?.componentInstance) {
      this.importLogDialogRef.componentInstance.appendLogLines(allLines);
      return;
    }
    this.importLogPopup(allLines, this.buildLogFileNameCandidates());
  }

  private buildPopupLogs(extraLines: string[] = []): string[] {
    const combined = [...this.uploadProgressLogs, ...extraLines]
      .map((line) => String(line || '').trim())
      .filter(Boolean);
    return Array.from(new Set(combined));
  }

  private extractLogLines(source: any, seen = new Set<any>()): string[] {
    if (source === null || source === undefined) {
      return [];
    }

    if (typeof source === 'string') {
      return source
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean);
    }

    if (typeof source !== 'object') {
      return [];
    }

    if (seen.has(source)) {
      return [];
    }
    seen.add(source);

    if (Array.isArray(source)) {
      return source.flatMap((item) => this.extractLogLines(item, seen));
    }

    const directKeys = ['message', 'msg', 'logMessage', 'error', 'errorMessage', 'statusMessage'];
    const directLines = directKeys
      .map((key) => source?.[key])
      .flatMap((value) => this.extractLogLines(value, seen));

    const nestedKeys = ['backendResponse', 'body', 'logs', 'data', 'messages', 'details', 'payload', 'response'];
    const nestedLines = nestedKeys
      .map((key) => source?.[key])
      .flatMap((value) => this.extractLogLines(value, seen));

    return [...directLines, ...nestedLines];
  }

  private isTerminalUploadMessage(message: any): boolean {
    const status = String(message?.status || '').toLowerCase();
    if (status === 'success' || status === 'failed' || status === 'error') {
      return true;
    }

    return this.isFinalBackendResponsePayload(message?.backendResponse);
  }

  private isFinalBackendResponsePayload(backendResponse: any): boolean {
    if (!backendResponse || typeof backendResponse !== 'object') {
      return false;
    }

    if (backendResponse.error) {
      return true;
    }

    if (backendResponse.fileBase64 || backendResponse.reportDownloadUrl) {
      return true;
    }

    if (backendResponse.status !== undefined && backendResponse.status !== null) {
      const statusCode = Number(backendResponse.status);
      if (!Number.isNaN(statusCode)) {
        return statusCode === 200 || statusCode === 207 || statusCode >= 400;
      }
    }

    const message = String(backendResponse.message || backendResponse.statusMessage || '').toLowerCase();
    if (message.includes('validation failed') || message.includes('uploaded successfully') || message.includes('validated successfully')) {
      return true;
    }

    return false;
  }

  private buildLogFileNameCandidates(): string[] {
    const fromPath = this.selectedFilePath?.split('/')?.pop?.() || '';
    const candidates = [
      this.templateFile?.name,
      this.selectedFileName,
      fromPath,
    ]
      .map((value) => String(value || '').trim())
      .filter(Boolean);

    return Array.from(new Set(candidates));
  }

  importLogPopup(preloadedLogs: string[] = [], logFileNames: string[] = []) {
    this.dialog.open(ImportLogComponent, {
      width: '619px', height: '400px', data: {
        fileSend: this.templateFile,
        valueSend: this.value,
        logsSend: preloadedLogs,
        logFileNames
      }
    });

  }

  close() {
    this.errorMessage = null;
    this.successMessage = null;
  }

  onUpdateEvent(event) {

    this.templateFile = event;
  }
  dateValidation() {
    this.errorMessage = null;
    this.successMessage = null;
    let returnVal = true;
    for (const ele of this.columnFilterArr) {
      if ((ele.colId == 'startTime' && ele['value'] && !moment(ele['value'], 'MM/DD/YYYY', true).isValid()) || (ele.colId == 'finishTime' && ele['value'] && !moment(ele['value'], 'MM/DD/YYYY', true).isValid())) { // NOSONAR
        returnVal = false;
        this.errorMessage = "Please enter a valid date format (MM/DD/YYYY)";
        break;
      }
    }
    return returnVal;
  }

  filterAPI() {
    const filter = {};
    // VALIDATION GOES HERE...
    if (!this.dateValidation()) {
      return
    }
    this.columnFilterArr.forEach(ele => {
      if (ele['value']) {
        filter[ele.colId] = ele;
      }
    });

    if (Object.keys(filter).length > 0) {
      this.filterApiCall(filter);
    } else {
      this.apiCall(this.paginationPageSize);
    }
  }

  filterApiCall(filter) {
    this.errorMessage = null;
    this.successMessage = null;
    let queryString = '';
    Object.keys(filter).forEach((key, index) => {
      if (index == 0) { // NOSONAR
        queryString += '?';
      }
      queryString += `${key}=${filter[key].value}`
      if (Object.keys(filter).length - 1 != index) {
        queryString += '&';
      }
    });
    const data = {
      pageNumber: this.pageNumber,
      pageSize: this.paginationPageSize,
      queryString: queryString
    }
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.displayRowData = [];
    this.summaryService.searchJobs(data)?.subscribe(
      (response: any) => {

        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.displayRowData = response.liosJobLogList.map((item: any) => {
          return {
            ...item,
            startTime: this.dateFormatter(item.startTime),
            finishTime: this.dateFormatter(item.finishTime),
          };
        });
        this.gridApi.applyTransaction({ add: this.displayRowData });
        this.rowCount = response.navOptions.totalRecords;
        this.currentPageCheck = response.navOptions.page;
        this.totalPageCheck = response.navOptions.numberOfPages;
        if (response.liosJobLogList.length == 0) { // NOSONAR
          this.currentPageCheck = 0;
          this.totalPageCheck = 0;
          this.setText(this.const_crp, this.currentPageCheck);
          this.setText(this.const_tl, this.totalPageCheck);
        }
        this.gridApi?.redrawRows();
      },
      error => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
        this.gridApi.applyTransaction({ add: this.displayRowData });
        console.info(error)
      });
  }
}

function monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 16) { // NOSONAR
    return null;
  }
  const minNumber = Number.parseInt(date.substring(14, 16));
  const hourNumber = Number.parseInt(date.substring(11, 13));

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));

  return yearNumber * 100000000 + monthNumber * 1000000 + dayNumber * 10000 + hourNumber * 100 + minNumber;
}


